import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import FontAwesomeIcon from '../../../common/FontAwesomeIcon';
import formatCurrency from '../../../../utils/formatCurrency';

const FinanceHeader = (props) => {
    const user = useSelector((state) => state.auth.user); // foto, name, personal_email

    const { current_balance_usd, total_investment_usd } = props;

    const isUpToDate = current_balance_usd <= 0;

    return (
        <HeaderContainer isUpToDate={isUpToDate}>
            <section>
                <img
                    src={user?.foto}
                    alt="User"
                    style={{
                        borderRadius: '50%',
                        width: '100px',
                        height: '100px',
                    }}
                />
                <span>
                    <h5>{user?.name}</h5>
                    <h6>{user?.personal_email}</h6>
                    {/* <label>
                        {isUpToDate ? (
                            <>
                                <FontAwesomeIcon icon="fa-solid fa-check" />
                                Al día
                            </>
                        ) : (
                            <>En deuda</>
                        )}
                    </label> */}
                </span>
            </section>
            <section>
                <InfoCard color="#28A986">
                    <label>INVERSIÓN TOTAL</label>
                    <h7>{formatCurrency(total_investment_usd)}</h7>
                </InfoCard>
                <InfoCard color="#E94C44">
                    <label>POR PAGAR</label>
                    <h7>{formatCurrency(current_balance_usd)}</h7>
                </InfoCard>
            </section>
        </HeaderContainer>
    );
};

export default FinanceHeader;

const HeaderContainer = styled.div`
    width: calc(100% - 4rem);
    height: 180px;
    background-color: #f7f7f7;
    border: 1px solid #a8a8a8;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;

    section {
        display: flex;
        gap: 1rem;

        span {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            h5 {
                font-size: 20px;
                font-weight: 700;
                color: #222;
            }

            h6 {
                font-size: 16px;
                font-weight: 500;
                color: #222;
            }

            label {
                width: fit-content;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: ${(props) =>
                    props.isUpToDate ? '8px 16px 8px 10px' : '8px 16px'};
                background-color: ${(props) =>
                    props.isUpToDate ? '#28A986' : '#E94C44'};
                border-radius: 100px;
                color: #fff;
            }
        }
    }

    @media (width < 1000px) {
        height: fit-content;
        flex-direction: column;
        align-items: start;
        gap: 1rem;
        padding: 1rem;
    }

    @media (width < 768px) {
        width: calc(100% - 2rem);
    }
`;

const InfoCard = styled.div`
    width: 200px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 600;

    label {
        color: ${(props) => props.color || '#000'};
    }

    @media (width < 768px) {
        min-width: 50%;
        width: fit-content;
    }
`;
